const getters = {
  getCouponCode: state => state.couponCode,

  GET_USER_AUTHENTICATED: state => state.userAuthenticated,

  GET_ACTIVE_STEP: state => state.activeStep,

  GET_SELECTED_PLAN: state => state.selectedPlan,

  GET_GIFT_DATA: state => state.giftData,

  GET_USER_ADDRESS: state => state.userData.address,

  GET_USER_INVOICE: state => state.userData.invoice,

  GET_USER_SUBSCRIPTION_TYPE: state => state.userData.subscription_type,

  GET_USER_SUBSCRIPTION_EXPIRES_IN_TWO_WEEKS: state => state.userData.subscription_expires_as_two_weeks,

  GET_USER_CYCLICAL_SUBSCRIPTION_ON: state => state.userData.has_cyclical_subscription,
};
export default getters;
